// src/pages/admin/DashboardHome.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PieChartComponent from "../../components/charts/PieChart";
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FaUserTie } from 'react-icons/fa';
import { FaFileInvoice } from 'react-icons/fa';
import { FaBell } from 'react-icons/fa';
import { FaUserShield } from 'react-icons/fa';
import { FaUserCog } from 'react-icons/fa';
import { FaMapMarkedAlt } from 'react-icons/fa';
import { FaMoneyBill } from 'react-icons/fa';
import { FaChartLine } from 'react-icons/fa';
import { FaChartBar } from 'react-icons/fa';
import { FaBuilding } from 'react-icons/fa';
import { FaCalendar } from 'react-icons/fa';
import { FaAddressCard } from 'react-icons/fa';
import { FaUsers } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import { FaClock } from 'react-icons/fa';

const DashboardHome = () => {
  const [counts, setCounts] = useState([]);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const counts = [];
        const collections = [
  { collection: 'employees', title: 'Employees', style: { backgroundColor: '#cce5ff', color: '#004085' }, icon: <FaUserShield /> },
  { collection: 'locations', title: 'Locations', style: { backgroundColor: '#d4edda', color: '#155724' }, icon: <FaMapMarkedAlt /> },
  { collection: 'companyheads', title: 'Company Heads', style: { backgroundColor: '#f8d7da', color: '#721c24' }, icon: <FaUserCog /> },
  { collection: 'quotations', title: 'Quotations', style: { backgroundColor: '#fff3cd', color: '#856404' }, icon: <FaMoneyBill /> },
  { collection: 'reminders', title: 'Reminders', style: { backgroundColor: '#d1ecf1', color: '#0c5460' }, icon: <FaBell /> },
  { collection: 'roles', title: 'Roles', style: { backgroundColor: '#e2e3e5', color: '#383d41' }, icon: <FaAddressCard /> },
  { collection: 'stations', title: 'Stations', style: { backgroundColor: '#f5c6cb', color: '#721c24' }, icon: <FaCalendar /> },
  { collection: 'telecallingpayments', title: 'Tele-calling Payments', style: {backgroundColor: '#c3e6cb', color: '#155724', fontSize: '0.8rem' }, icon: <FaChartBar /> },
  { collection: 'telecallingsales', title: 'Tele-calling Sales', style: { backgroundColor: '#ffeeba', color: '#856404', fontSize: '0.8rem' }, icon: <FaChartLine /> },
  { collection: 'items', title: 'Items', style: { backgroundColor: '#bee5eb', color: '#0c5460' }, icon: <FaBuilding /> },
  { collection: 'fieldvisits', title: 'Field Visits', style: { backgroundColor: '#f8d7da', color: '#721c24' }, icon: <FaMapMarkerAlt /> },
  { collection: 'categories', title: 'Categories', style: { backgroundColor: '#d4edda', color: '#155724' }, icon: <FaUserTie /> },
  { collection: 'companies', title: 'Companies', style: { backgroundColor: '#cce5ff', color: '#004085' }, icon: <FaHome /> },
  { collection: 'customers', title: 'Customers', style: { backgroundColor: '#fff3cd', color: '#856404' }, icon: <FaUsers /> },
  { collection: 'dealers', title: 'Dealers', style: { backgroundColor: '#d1ecf1', color: '#0c5460' }, icon: <FaAddressCard /> },
  { collection: 'deliveryorders', title: 'Delivery Orders', style: { backgroundColor: '#e2e3e5', color: '#383d41' }, icon: <FaFileInvoice /> },
  { collection: 'brands', title: 'Brands', style: { backgroundColor: '#f5c6cb', color: '#721c24' }, icon: <FaChartLine /> },
  { collection: 'buyers', title: 'Buyers', style: { backgroundColor: '#c3e6cb', color: '#155724' }, icon: <FaUserShield /> },
  { collection: 'feedbacks', title: 'Feedbacks', style: { backgroundColor: '#ffeeba', color: '#856404' }, icon: <FaChartBar /> },
  { collection: 'activitylogs', title: 'Activity Logs', style: { backgroundColor: '#bee5eb', color: '#0c5460' }, icon: <FaClock /> },
];
        await Promise.all(collections.map(async (data) => {
          const collection = data.collection;
          const title = data.title;
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/dashboard/count/${collection}`);
          counts.push({ collection, title, count: res.data.count,...data });
        }));
        setCounts(counts);
      } catch (error) {
        console.error("Error fetching counts:", error);
      }
    };

    fetchCounts();
  }, []);

 const pieCharts = [{
  api: "/dashboard/employee-count-by-company",
  title: "Employee Count by Company",
  ApiResponseField: "company"
 },
 {
  api: "/dashboard/company-head-count-by-company",
  title: "Company Head Count by Company",
  ApiResponseField: "company"
 },{
  api: "/dashboard/item-count-by-brand",
  title: "Item Count by Brand",
  ApiResponseField: "brand"
 },{
  api: "/dashboard/item-count-by-category",
  title: "Item Count by Category",
  ApiResponseField: "category"
 },{
   api: "/dashboard/employee-count-by-role",
   title: "Employee Count by Role",
   ApiResponseField: "role"
 },
 {
  api: "/dashboard/leave-count-by-status",
   title: "Leave Count by Status",
   ApiResponseField: "status"
 },{
  api: "/dashboard/employee-count-by-location",
   title: "Employee Count by Location",
   ApiResponseField: "location"
 }]

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-6" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))" }}>
        {counts.map((count, index) => (
          <div className="bg-white shadow rounded-lg p-6 flex flex-col justify-center items-center" style={count.style} key={index}>
            <div className="flex items-center mb-2">
              {count.icon && <span className="mr-2 text-2xl">{count.icon}</span>}
              <h2 className="font-semibold" style={{ fontSize: '0.12rem !important' }}>{count.title}</h2>
            </div>
            <p className="text-4xl font-bold">{count.count}</p>
          </div>
        ))}
      </div>
      <div className="mt-8">
        <PieChartComponent data={pieCharts} />
      </div>
    </div>
  );

};
export default DashboardHome;
